import { render, staticRenderFns } from "./SimpleListItem.vue?vue&type=template&id=f7a56c2e&scoped=true&"
import script from "./SimpleListItem.vue?vue&type=script&lang=js&"
export * from "./SimpleListItem.vue?vue&type=script&lang=js&"
import style0 from "./SimpleListItem.vue?vue&type=style&index=0&id=f7a56c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a56c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
